import type { SVGProps } from 'react';
export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M12.8 5.2c.27.25.27.66 0 .91L8.67 10l4.13 3.89c.27.25.27.66 0 .92a.7.7 0 0 1-.98 0L7.2 10.46a.63.63 0 0 1 0-.92l4.62-4.35c.27-.25.7-.25.98 0"
      clipRule="evenodd"
    />
  </svg>
);
